import { render, staticRenderFns } from "./Bet.vue?vue&type=template&id=4af59ae1&scoped=true"
import script from "./Bet.vue?vue&type=script&lang=js"
export * from "./Bet.vue?vue&type=script&lang=js"
import style0 from "./Bet.vue?vue&type=style&index=0&id=4af59ae1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af59ae1",
  null
  
)

export default component.exports